
































































































































































































































































































































import { Component, Vue } from "vue-property-decorator";
import { ssmHttpService } from "@/shared/services/http-service";
import { API } from "@/shared/api";
import { MessageService } from "@/shared/services/message-service";
import { cache_diagnostics_entry } from "@/shared/dtos/logs/cache_diagnostics_entry";
import { RouterNames } from "@/router/routernames";

@Component({ name: "CacheDiagnosticsViewer" })
export default class CacheDiagnosticsViewer extends Vue {
  public entries: cache_diagnostics_entry[] = [];
  public loading = false;
  public warmingUp = false;
  public autoRefresh = true;
  public filterType = "Todos";
  public infoDialog = false;
  private timer: any = null;

  public typeOptions = ["Todos", "doctores_raw", "huecos", "doctores_tablero"];

  public headers = [
    { text: "Tipo", value: "Type", width: "160px" },
    { text: "Descripción", value: "Label" },
    { text: "Estado", value: "IsAlive", width: "110px", align: "center" },
    { text: "Cacheado", value: "SetAt", width: "160px" },
    { text: "Expira en", value: "RemainingSeconds", width: "120px", align: "right" },
    { text: "Acción", value: "actions", width: "80px", align: "center", sortable: false },
  ];

  public get filteredEntries(): cache_diagnostics_entry[] {
    if (this.filterType === "Todos") return this.entries;
    return this.entries.filter((e) => e.Type === this.filterType);
  }

  public get aliveCount(): number {
    return this.entries.filter((e) => e.IsAlive).length;
  }

  public mounted() {
    this.loadData();
    this.startTimer();
  }

  public beforeDestroy() {
    this.stopTimer();
  }

  private startTimer() {
    this.stopTimer();
    this.timer = setInterval(() => {
      if (this.autoRefresh && !this.loading) this.loadData();
    }, 30000);
  }

  private stopTimer() {
    if (this.timer) { clearInterval(this.timer); this.timer = null; }
  }

  public toggleAutoRefresh() {
    this.autoRefresh = !this.autoRefresh;
  }

  public goToRequestsLog() {
    this.$router.push({ name: RouterNames.public_agenda_requests_log_admin });
  }

  public async loadData() {
    this.loading = true;
    try {
      const data = await ssmHttpService.get(API.cacheDiagnostics, null, false);
      this.entries = data || [];
    } catch (e) {
      MessageService.toast("Error cargando diagnóstico de caché", MessageService.TypeError);
    } finally {
      this.loading = false;
    }
  }

  public async invalidate(key: string) {
    MessageService.confirm("¿Invalidar esta entrada de caché?", "Confirmar", async (ok: boolean) => {
      if (!ok) return;
      try {
        await ssmHttpService.delete(`${API.cacheDiagnostics}/${encodeURIComponent(key)}`, null, false);
        MessageService.toast("Entrada invalidada");
        await this.loadData();
      } catch (e) {
        MessageService.toast("Error invalidando entrada", MessageService.TypeError);
      }
    });
  }

  public async triggerWarmup() {
    this.warmingUp = true;
    try {
      await ssmHttpService.post(`${API.cacheDiagnostics}/warmup`, null, false);
      MessageService.toast("Warmup disparado. Los datos se actualizarán en unos segundos.");
      setTimeout(() => this.loadData(), 5000);
    } catch (e) {
      MessageService.toast("Error al disparar warmup", MessageService.TypeError);
    } finally {
      this.warmingUp = false;
    }
  }

  public typeColor(type: string): string {
    switch (type) {
      case "doctores_raw": return "blue darken-1";
      case "huecos": return "teal darken-1";
      case "doctores_tablero": return "purple darken-1";
      default: return "grey darken-1";
    }
  }

  public formatTime(dateStr: string): string {
    if (!dateStr) return "---";
    return new Date(dateStr).toLocaleTimeString("es-ES", { hour: "2-digit", minute: "2-digit", second: "2-digit" });
  }

  public formatRemaining(secs: number): string {
    if (secs <= 0) return "Expirado";
    if (secs < 60) return `${secs}s`;
    const m = Math.floor(secs / 60);
    if (m < 60) return `${m}m ${secs % 60}s`;
    const h = Math.floor(m / 60);
    return `${h}h ${m % 60}m`;
  }
}
